
<div class="mobile-view-only" style="text-align:center;">
  <header class="header-center-panal" style="text-align:center">
    <h3 style="font-size: 15px;">Payment Method</h3>
  </header>
  <hr>
  <p class="sub-header-left-panal" style="text-align:center;font-size: 12px;">Choose credit or ACH to
    pay
    invoices and enter billing information
  </p>
</div>
<div id="wrapper" style="position:relative">

<iframe id="iframeVale" allowtransparency="true" [src]="pacUrl"
  scrolling="no"
  frameborder="0"  allowfullscreen>
</iframe>
</div>
<!-- <iframe id="iframeVale" [src]="pacUrl"></iframe> -->